import { Component, Input, OnInit } from '@angular/core';
import { EvaluationVehicle } from '@app-model/evaluation';
import { Vehicle } from '@app-model/vehicle';

@Component({
  selector: 'app-card-truck-cabin',
  templateUrl: './card-truck-cabin.component.html',
  styleUrls: ['./card-truck-cabin.component.scss']
})
export class CardTruckCabinComponent implements OnInit {

  @Input() castOffVehicle?: Vehicle;
  @Input() vehicle?: EvaluationVehicle;

  get data(): Vehicle | EvaluationVehicle | undefined {
    return this.castOffVehicle || this.vehicle;
  }

  typeLabel: string;
  subtypeLabel: string;
  cabin: string;

 cabineTypes = [
    { id: 'CONVENTIONAL',     name: 'Convencional'       },
    { id: 'ADVANCED',          name: 'Avançado'           },
    { id: 'SEMI_ADVANCED',     name: 'Semi Avançada'      },
    { id: 'BED_HIGH_CEILING',  name: 'Leito Teto Alto'   },
    { id: 'EXTENDED_LOW_CEILING', name: 'Estendida Teto Baixo' },
    { id: 'HIGH_CEILING',       name: 'Teto Alto'         },
    { id: 'LOW_CEILING',        name: 'Teto Baixo'        }
  ];

  constructor() { }

  ngOnInit(): void {
    if (this.castOffVehicle) {
      const raw = this.castOffVehicle.truckCabin || '';
      if (!raw) { return; }

      if (raw.startsWith('SEMI_ADVANCED'))      this.cabin = CabinTruckIcon.SEMI_ADVANCED;
      else if (raw.startsWith('ADVANCED'))      this.cabin = CabinTruckIcon.ADVANCED;
      else                                       this.cabin = CabinTruckIcon.CONVENTIONAL;

      const parts = raw.split('_');
      const prefixRaw = parts[0] === 'SEMI'
        ? parts.slice(0,2).join('_')
        : parts[0];
      const subtypeRaw = parts[0] === 'SEMI'
        ? parts.slice(2).join('_')
        : parts.slice(1).join('_');

      const prefixEntry  = this.cabineTypes.find(c => c.id === prefixRaw);
      const subtypeEntry = this.cabineTypes.find(c => c.id === subtypeRaw);

      this.typeLabel    = prefixEntry?.name  || prefixRaw.replace(/_/g,' ');
      this.subtypeLabel = subtypeEntry?.name || subtypeRaw.replace(/_/g,' ');

    } else if (this.vehicle) {
      const rawLabel = this.vehicle.truckCabinLabel || '';
      const rawEnum = this.vehicle.truckCabin || '';
      if (rawEnum.startsWith('SEMI_ADVANCED'))      this.cabin = CabinTruckIcon.SEMI_ADVANCED;
      else if (rawEnum.startsWith('ADVANCED'))      this.cabin = CabinTruckIcon.ADVANCED;
      else                                           this.cabin = CabinTruckIcon.CONVENTIONAL;

      const parts = rawLabel.split(' ');
      if (rawEnum.startsWith('SEMI_ADVANCED')) {
        this.typeLabel    = parts.slice(0,2).join(' ');
        this.subtypeLabel = parts.slice(2).join(' ');
      } else {
        this.typeLabel    = parts[0];
        this.subtypeLabel = parts.slice(1).join(' ');
      }
    }
  }

}

export enum CabinTruckIcon {
  CONVENTIONAL = 'aar-icon-conventional',
  SEMI_ADVANCED = 'aar-icon-semi-advanced',
  ADVANCED = 'aar-icon-advanced',
}
